import { createRouter, createWebHistory } from "vue-router";

import LoginView from "@/views/LoginView.vue";
import PageView from "@/views/PageView.vue";
import HomeView from "@/views/page/HomeView.vue";
import GalleryPreviewView from "@/views/page/GalleryPreviewView.vue";
import StatsView from "@/views/page/StatsView.vue";

import { supabase } from "@/ts/supabase";

const router = createRouter({
	history: createWebHistory(import.meta.env.BASE_URL),
	routes: [
		{
			path: "/",
			name: "main",
			component: PageView,
			children: [
				{
					name: "home",
					path: "/",
					component: HomeView,
				},
				{
					path: "/gallery-preview",
					name: "galleryPreview",
					component: GalleryPreviewView
				},
				{
					path: "/stats",
					name: "stats",
					component: StatsView
				}
			]
		},
		{
			path: "/login",
			name: "login",
			component: LoginView
		}
	]
});

router.beforeEach(async (to, from, next) => {
	const { error } = await supabase.auth.getUser();

	if (error && to.name !== "login") {
		next("login");
		return;
	} else if (!error && to.name == "login") {
		next(from);
		return;
	}

	next();
});

export default router;
